<template>
    <div class="sub-menu-suspenso">
        <button @click="mostrarMenu=true"> <img src="..\assets\menu-bar.png"></button>
    </div>
    <div class="sub-menu" v-if="mostrarMenu==true">
        <div class="botao-top">
            <router-link to="/"><img src="..\assets\home.png"></router-link>
            <button @click="mostrarMenu=false"  class="btn-fechar-menu"><img src="..\assets\close.png"></button>
        </div>
        <div class="wrapper">
            <h1>Mais + </h1>
            <ul class="botoes">                        
                <li><router-link to="/mais/relatdespesasemanal" class="botao" @click="mostrarMenu=false">Despesas Semanal</router-link></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  data: () => ({
    mostrarMenu: true
  })
}
</script>

<style>

</style>